import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import LayoutWithList from "../../../../LayoutModal/WithList";
import ActionButton from "../../../../Button/ActionButton";
import Delete from "../../../../../components/Modals/Delete";
import Update from "../Update";
//hooks
import apiRequest from "../../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../../hooks/useMultipleModal";
import { useEffect, useState } from "react";
//Icons
import { PencilSimple, Trash } from "@phosphor-icons/react";
//Interfaces
import { Inputs, ICategory } from "Interfaces/ICategory";

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateCategory({
  isOpenModal,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    resetField,
    formState: { errors },
  } = useForm<Inputs>();

  const tableHead = ["#", "Nome", "Ações"];

  const [category, setCategory] = useState<ICategory[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const { isOpenModal: isOpenModalVisible, toggleModalVisibility } = useMultipleModal();

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`category-expense`);
      setCategory(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModal && category.length === 0) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {

      const formattedData = {
        category_expense: data.category_expense.toUpperCase(), // Aqui você força caixa alta
      };

      const response = await apiRequest("category-expense", "POST", formattedData);
      if (response.status === 201) {
        alert("Categoria criada com sucesso!");
        fetchData();
        refreshFrames();
        // resetField('category_expense');
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModal) {
    return (
      <LayoutWithList
        title="Registrar Categoria"
        subTitle="Cadastre uma nova categoria em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nome da categoria
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da categoria"
                type="text"
                {...register("category_expense", { required: true })}
              />
              {errors.category_expense && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipo de Categoria Cadastradas</S.TitleList>

          <S.Table>
            <thead>
              <tr>
                {tableHead.map((val) => {
                  return <th>{val}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {category.map((val, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.category_expense}</td>
                    <td>
                      <S.ContentButton>
                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "update")}
                        >
                          <PencilSimple size={20} />
                        </S.ButtonIconTable>

                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "delete")}
                        >
                          <Trash size={20} color="red" />
                        </S.ButtonIconTable>
                      </S.ContentButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </S.Table>
        </S.Footer>

        <Update
          isOpenModalMaterial={isOpenModalVisible("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="category-expense"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModalVisible("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        /> 
      </LayoutWithList>
    );
  }
  return null;
}
